import Icon from 'react-icon-base';

const SergicBadge = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="12" cy="12" r="12" fill="#ffffff" fillRule="nonzero" />
      <path fill="#0080C8" d="M6.683 7.213L4 16.711h2.33l2.681-9.498z" />
      <path
        fill="#0080C8"
        d="M15.859 10.78c2.256.388 3.88.903 3.88 2.969 0 1.882-1.66 3.208-3.987 3.208-2.31 0-4.021-1.272-4.304-3.32h2.364c.316.813 1.252 1.108 1.94 1.108.935 0 1.64-.295 1.64-.848 0-.535-.318-.756-1.904-1.015-1.623-.259-3.795-.718-3.795-2.84C11.693 8.55 12.946 7 15.576 7c2.082 0 3.635 1.18 3.935 2.967h-2.418c-.142-.441-.652-.792-1.517-.792-1.076 0-1.517.406-1.517.756 0 .5.671.664 1.8.85v-.001z"
      />
    </g>
  </Icon>
);

export default SergicBadge;
